import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export type StoreCustomerManagementUpdateGlobalCustomerRequest = {
    phone: string;
    platform: any;
    source: any;
    updatableData: {
        countryCode: string;
        isSmsOptin: boolean;
        isCallOptin: boolean;
    };
    SsoRequirement: {
        customerType: any;
    };
};

const updateGlobalCustomerByPhone = (data: StoreCustomerManagementUpdateGlobalCustomerRequest) =>
    request({
        url: ApiURL.Command.updateGlobalCustomerByPhone,
        method: RequestType.POST,
        data,
    });

export const StoreCustomerManagementCommand = {
    updateGlobalCustomerByPhone,
};
